import {useCallback} from 'react'
import {useSyncedState} from '@github-ui/use-synced-state'
import {Filter} from '@github-ui/filter'
import type {FilterQuery} from '@github-ui/filter-core'

import styles from './Search.module.css'

type Props = {
  searchQuery: string
  onSearchChange: (query: string) => void
}

export function Search({searchQuery, onSearchChange}: Props) {
  // Local value stays in sync with the searchQuery prop (e.g., from URL),
  // while still allowing the user to type without triggering a search.
  const [localValue, setLocalValue] = useSyncedState(searchQuery)

  const handleQueryChange = useCallback(
    (value: string) => {
      // Update local state to show what user is typing, but don't trigger search
      setLocalValue(value)
    },
    [setLocalValue],
  )

  const handleSubmit = useCallback(
    (filterQuery: FilterQuery) => {
      onSearchChange(filterQuery.raw)
    },
    [onSearchChange],
  )

  return (
    <Filter
      id="agent-finder-search-filter"
      data-testid="agent-finder-search-filter"
      providers={[]}
      label="Search Agent Finder"
      variant="input"
      filterValue={localValue}
      className={styles.input}
      placeholder={'Search resources'}
      settings={{
        disableAdvancedTextFilter: true,
        groupAndKeywordSupport: false,
      }}
      onChange={handleQueryChange}
      onSubmit={handleSubmit}
    />
  )
}
